export enum EVictimsType {
  People = 'People',
  Animal = 'Animal'
}
